<template>
  <img :src="full_call_details" alt="" width="100%" />
</template>

<script>
import full_call_details from "@/assets/images/full_call_details.svg";
export default {
  name: "SpeechSkeleton",
  data() {
    return {
      full_call_details,
    };
  },
};
</script>

<style scoped></style>
